import { Routes } from '@angular/router';
import { AuthGuard } from '@core/services/auth/auth-guard.service';
import { AuthorityGuard } from '@core/services/auth/authority-guard.service';

export const SETTINGS_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./settings.component').then(m => m.SettingsComponent),
    children: [
      {
        path: 'team-management',
        loadComponent: () => import('@modules/settings/team-management/team-management.component').then(m => m.TeamManagementComponent),
        data: {
          hasAuthority: 'VIEW_PAGE_TEAM_MANAGEMENT',
          breadcrumb: [{ label: 'Team Management', link: '/settings/team-management' }]
        },
        canActivate: [AuthGuard, AuthorityGuard],
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'teams'
          },
          {
            path: 'teams',
            title: 'Teams',
            loadComponent: () =>
            import('@modules/settings/team-management/teams/teams.component').then(m => m.TeamsComponent),
            data: { hasAuthority: 'VIEW_PAGE_TEAMS', breadcrumb: [{ label: 'Teams' }] },
            canActivate: [AuthorityGuard]
          }
        ]
      },
      {
        path: 'user-management',
        loadComponent: () => import('@modules/settings/user-management/user-management.component').then(m => m.UserManagementComponent),
        data: {
          hasAuthority: 'VIEW_PAGE_USER_MANAGEMENT',
          breadcrumb: [{ label: 'User Management', link: '/settings/user-management' }]
        },
        canActivate: [AuthGuard, AuthorityGuard],
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'users'
          },
          {
            path: 'users',
            title: 'Users',
            loadComponent: () =>
            import('@modules/settings/user-management/users/users.component').then(m => m.UsersComponent),
            data: { hasAuthority: 'VIEW_PAGE_USERS', breadcrumb: [{ label: 'Users' }] },
            canActivate: [AuthorityGuard]
          }
        ]
      },
      {
        path: 'ai-policies',
        loadComponent: () => import('@modules/settings/ai-policies/ai-policies.component').then(m => m.AiPoliciesComponent),
        data: { hasAuthority: 'MANAGE_AI_SETTINGS', breadcrumb: [{ label: 'AI policies' }] },
        canActivate: [AuthGuard, AuthorityGuard]
      },
      { // Every user has authority to see the account page
        path: 'account',
        loadComponent: () => import('@modules/settings/account/account.component').then(m => m.AccountComponent),
        data: { breadcrumb: [{ label: 'Account' }] },
        canActivate: [AuthGuard]
      },
      {
        path: 'billing-usage',
        loadComponent: () => import('@modules/settings/billing-usage/billing-usage.component').then(m => m.BillingUsageComponent),
        data: { hasAuthority: 'VIEW_PAGE_BILLING', breadcrumb: [{ label: 'Billing & usage' }] },
        canActivate: [AuthGuard, AuthorityGuard]
      },
      { // Every user has authority to see the account page
        path: 'billing',
        loadComponent: () => import('@modules/settings/billing/billing.component').then(m => m.BillingComponent),
        data: { hasAuthority: 'VIEW_PAGE_BILLING', breadcrumb: [{ label: 'Billing' }] },
        canActivate: [AuthGuard, AuthorityGuard]
      }
    ]
  }
];
